import { Avatar, AVATAR_HEIGHT_24 } from '../../../../../Avatar'
import { getListingPortalLabel } from '../../../../../RentalPortalListing'
import { TableCellBase, TableCellText } from '../../../../../Table'
import { getPortalAvatarProps } from '../../../../RentalPortal.utils'

import * as styles from './ListingProfilePublishingsPortalCell.module.css'

function ListingProfilePublishingsPortalCell({ publication, ...cellProps }) {
  return (
    <TableCellBase {...cellProps}>
      <Avatar
        {...getPortalAvatarProps(publication.portal)}
        className={styles.logo}
        size={AVATAR_HEIGHT_24}
      />
      <TableCellText value={getListingPortalLabel(publication.portal)} />
    </TableCellBase>
  )
}

export default ListingProfilePublishingsPortalCell
